import { useShallow } from 'zustand/react/shallow';

import { useBoundStore } from '@/store/store';

export function useCampaign() {
  return useBoundStore(useShallow(state => state.campaign));
}
